import React, { useState } from 'react'
import './CommonDesignGallery.css';
import { Link } from 'react-router-dom';


import Bedroomwithbrickwall1 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (1).jpg'
import Bedroomwithbrickwall2 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (10).jpg'
import Bedroomwithbrickwall3 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (3).jpg'
import Bedroomwithbrickwall4 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (4).jpg'
import Bedroomwithbrickwall5 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (5).jpg'
import Bedroomwithbrickwall6 from '../../assets/designgallery/Bedroom/bedroom_with_brickwallcladding/bedroom_with_brickwallcladding (6).jpg'


import Bedroomwithsleekdresserunit1 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (1).webp'
import Bedroomwithsleekdresserunit2 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (2).jpg'
import Bedroomwithsleekdresserunit3 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (3).jpg'
import Bedroomwithsleekdresserunit4 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (4).jpg'
import Bedroomwithsleekdresserunit5 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (4).webp'
import Bedroomwithsleekdresserunit6 from '../../assets/designgallery/Bedroom/Bedroom_With_Sleek_Dresser_TV Unit/bedroom_with_sleek_dresser_tvunit (6).jpg'
import { BiSolidOffer } from 'react-icons/bi';
import { MdOutlineReplay10, MdOutlineThumbUpAlt } from 'react-icons/md';


import Bedroomwithstudyarea1 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (1).jpg'
import Bedroomwithstudyarea2 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (2).jpg'
import Bedroomwithstudyarea3 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (3).jpg'
import Bedroomwithstudyarea4 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (4).jpg'
import Bedroomwithstudyarea5 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (5).jpg'
import Bedroomwithstudyarea6 from '../../assets/designgallery/Bedroom/bedrom_with_separateStudyArea/bedrroom_with_separate_studyarea (6).jpg'


import IndustrialBedroom1 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (8).jpg'
import IndustrialBedroom2 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (2).jpg'
import IndustrialBedroom3 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (3).jpg'
import IndustrialBedroom4 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (5).jpg'
import IndustrialBedroom5 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (6).jpg'
import IndustrialBedroom6 from '../../assets/designgallery/Bedroom/Industrial_style_bedroom/An_Industrial_bedroom_design (7).jpg'


import livingcumbedroom1 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (1).jpg'
import livingcumbedroom2 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (2).jpg'
import livingcumbedroom3 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (3).jpg'
import livingcumbedroom4 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (4).jpg'
import livingcumbedroom5 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (5).jpg'
import livingcumbedroom6 from '../../assets/designgallery/Bedroom/living_room_cum_bedroom/livingCumbedRoom (6).jpg'



const Bedroom = () => {
// ***********************************************
const [isExpanded1,setIsExpanded1]=useState(true);
const toggleContent1=()=>{
    setIsExpanded1(prev=>!prev)
};
// ***********************************************


// ***********************************************
const [isExpanded2,setIsExpanded2]=useState(false)
const toggleContent2=()=>{
    setIsExpanded2(prev=>!prev)
};
// ***********************************************

// // ***********************************************
// const [isExpanded3,setIsExpanded3]=useState(false)
// const toggleContent3=()=>{
//     setIsExpanded3(prev=>!prev)
// };
// // ***********************************************
  return (
    <div>
        <div className='bedroom design-gallery '>
            <div className='bedroom-heading container'>
                <h3>Bedroom Designs</h3>
                <p className='para'>
                    Explore our stunning bedroom designs. Transform your bedrrom with stylish, 
                    comfortabple and elegant interiors!
                </p>
            </div>
        {/*  **************************************************/}
        <div className='shapes container'>
            {/* slider-1 */}
            <div id="carouselExampleIndicators" class="carousel slide">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={ Bedroomwithbrickwall1} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ Bedroomwithbrickwall2} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ Bedroomwithbrickwall3} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ Bedroomwithbrickwall4} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ Bedroomwithbrickwall5} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ Bedroomwithbrickwall6} class="d-block w-100" alt="..."/>
                            </div>
                        </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                            </button>
            </div>
            <div className='images-details mt-3'>
                <p className='img-details-and-btn'>Modern Bedroom With Brick Wall Cladding <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
    
                {/* Show More button */}
                {!isExpanded1 && (
                    <button
                    className=" show-more btn mt-2"
                    onClick={toggleContent1}
                    aria-expanded={isExpanded1}
                    >
                    Show More ▼
                    </button>
                )}
    
                {/* Expanded content */}
                {isExpanded1 && (
                    <div className="extra-info mt-3 ">
                        <p className='extra-info-para'>
                            A modern bedroom designed with simplicity and sleekness. A wardrobe with space to
                            hang trousers, a bed with full area storage and a unit for books and decor make this bedroom a space 
                            saver's dream.
                        </p>
                        <p className='extra-info-features'>Special Features</p>
                        <ul className='extra-info-list'>
                        <li>Brick wall cladding for an industrial style aesthetics.</li>
                        <li>Tall wooden open bookshelf with pull-out storage.</li>
                        <li>King size bed with ample storage.</li>
                        <li>Shutter wardrobes with hanger space for trousers.</li>
                        </ul>
        
                        {/* Show Less button */}
                        <button
                            className=" show-less btn  mt-3"
                            onClick={toggleContent1}
                            aria-expanded={isExpanded1}
                        >
                            Show Less ▲
                        </button>
                    </div>
                )}
            </div>
        <div style={{margin:'80px'}}  ></div>


            {/* slider-1 end */}

            {/* slider-2 */}
            <div id="carouselExampleIndicators1" class="carousel slide">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={  Bedroomwithsleekdresserunit1} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithsleekdresserunit2} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithsleekdresserunit3} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithsleekdresserunit4} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithsleekdresserunit5} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithsleekdresserunit6} class="d-block w-100" alt="..."/>
                            </div>
                        </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                            </button>
            </div>
            <div className='images-details mt-3'>
                <p className='img-details-and-btn'>A Bedroom With A Sleek Dresser And TV Unit <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
    
                {/* Show More button */}
                {!isExpanded2 && (
                    <button
                    className=" show-more btn mt-2"
                    onClick={toggleContent2}
                    aria-expanded={isExpanded2}
                    >
                    Show More ▼
                    </button>
                )}
    
                {/* Expanded content */}
                {isExpanded2 && (
                    <div className="extra-info mt-3 ">
                        <p className='extra-info-para'>
                          This bedroom has a soothing aura to it thanks to an earthy colour scheme and a lot of woodwork. 
                          The room exhibits modern and stylish furniture pieces with a twist of Indian traditional design sensibilities.
                          It is kept organised and clutter-free with space-saving and modular furniture pieces.
                        </p>
                        <p className='extra-info-features'>Special Features</p>
                        <ul className='extra-info-list'>
                            <li>A gorgeous wooden laminate finished bed with a padded cushion headboard adds to the comfort of the space.</li>
                            <li>A sleek dressing unit in the same wooden laminate finish comes with handleless drawers and a full-length mirror.</li>
                            <li>An elegant wooden laminate TV unit with white laminate front handleless drawers and an open floating shelf complements the interiors of the bedroom.</li>
                            <li>A modular study unit, also in wooden laminate finish. has been designed with open shelf units.</li>
                            <li>The bedroom’s window bay seating improves the multifunctionality of the space.</li>
                            <li>A wooden ceiling fan with light adds lavishness to the whole bedroom setup</li>
                        </ul>
        
                        {/* Show Less button */}
                        <button
                            className=" show-less btn  mt-3"
                            onClick={toggleContent2}
                            aria-expanded={isExpanded2}
                        >
                            Show Less ▲
                        </button>
                    </div>
                )}
            </div>
        <div style={{margin:'80px'}}  ></div>

            {/* slider-2 end*/}
        </div>
        {/* ******************************** */}
        
                
                {/*whychooseourkitchen*/}
                    <div className='whyourkitchen'>
                      <h3>Why Choose Our Bedroom Designs</h3>
                      <div className='whyourkitchen-reason'>
                        <div className='icon-para-div1'>
                          <BiSolidOffer className='icon'/>
                          <p className='whyourkitchen-para'>20% Extra Space</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineReplay10  className='icon'/>
                          <p className='whyourkitchen-para'>10 Year Warranty</p>
                        </div>
                        <div className='icon-para-div1'>
                          <MdOutlineThumbUpAlt  className='icon'/>
                          <p className='whyourkitchen-para'>Installation by Professionals</p>
                        </div>
                      </div>
                    </div>
                {/*whychooseourkitchen*/}
        
        
              {/* ******************************** */}
        <div className='shapes container'>
            {/* Slider 3 */}
            <div id="carouselExampleIndicators3" class="carousel slide">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={  Bedroomwithstudyarea1} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithstudyarea2} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithstudyarea3} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithstudyarea4} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithstudyarea5} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={  Bedroomwithstudyarea6} class="d-block w-100" alt="..."/>
                            </div>
                        </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                            </button>
            </div>
            <div className='images-details mt-3'>
                <p className='img-details-and-btn'>A Modern Bedroom With A Separate Study Area <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
    
                {/* Show More button */}
                {!isExpanded2 && (
                    <button
                    className=" show-more btn mt-2"
                    onClick={toggleContent2}
                    aria-expanded={isExpanded2}
                    >
                    Show More ▼
                    </button>
                )}
    
                {/* Expanded content */}
                {isExpanded2 && (
                    <div className="extra-info mt-3 ">
                        <p className='extra-info-para'>
                           This bedroom,in gray and wood, creates an elegant yet bold statement .While the smart design
                           blends style and functionality, the multifunctional furniture pieces
                           make the space ideal for millenial working couples.
                        </p>
                        <p className='extra-info-features'>Special Features</p>
                        <ul className='extra-info-list'>
                            <li>A king-size bed with twin bedside cabinets and an accent wall.</li>
                            <li>A four-door ightwood laminate wardrobe with separate His and His section.</li>
                            <li>An ergonomic study area separated by a partititon with a wall-mounted desk and overhead cabinets.</li>
                            <li>The study table comes with two handleless drawers to arrage your books and stationaries in a  clutter-free manner.</li>
                            <li>A wallmounted bookshelf and accent chair on the other side of the study unit to enjoy some leisure time between work.</li>
                        </ul>
        
                        {/* Show Less button */}
                        <button
                            className=" show-less btn  mt-3"
                            onClick={toggleContent2}
                            aria-expanded={isExpanded2}
                        >
                            Show Less ▲
                        </button>
                    </div>
                )}
            </div>
        <div style={{margin:'80px'}}  ></div>
    
            {/* Slider 3  end*/}

            {/* slider 4 */}
            <div id="carouselExampleIndicators4" class="carousel slide">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={ IndustrialBedroom1} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ IndustrialBedroom2} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ IndustrialBedroom3} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ IndustrialBedroom4} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ IndustrialBedroom5} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ IndustrialBedroom6} class="d-block w-100" alt="..."/>
                            </div>
                        </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                            </button>
            </div>
            <div className='images-details mt-3'>
                <p className='img-details-and-btn'>An Industrial Style Bedroom design <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
    
                {/* Show More button */}
                {!isExpanded2 && (
                    <button
                    className=" show-more btn mt-2"
                    onClick={toggleContent2}
                    aria-expanded={isExpanded2}
                    >
                    Show More ▼
                    </button>
                )}
    
                {/* Expanded content */}
                {isExpanded2 && (
                    <div className="extra-info mt-3 ">
                        <p className='extra-info-para'>
                          An industrial style bedroom with an exposed brick wall and pops of color.An all black,sleek sliding door wardrobe lends an edgy look to this space
                        </p>
                        <p className='extra-info-features'>Special Features</p>
                        <ul className='extra-info-list'>
                            <li>A sliding door wardrobe with multiple compartments.</li>
                            <li>A study table adjoints the wardrobe built with overhead cabinets and shelves</li>
                            <li>A walk in dresser unit with tall shelves on the side</li>
                        </ul>
        
                        {/* Show Less button */}
                        <button
                            className=" show-less btn  mt-3"
                            onClick={toggleContent2}
                            aria-expanded={isExpanded2}
                        >
                            Show Less ▲
                        </button>
                    </div>
                )}
            </div>
        <div style={{margin:'80px'}}  ></div>
    
                






            {/* slider 4 -end*/}

            {/* slider 5 */}
                <div id="carouselExampleIndicators5" class="carousel slide">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src={ livingcumbedroom1} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ livingcumbedroom2} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ livingcumbedroom3} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ livingcumbedroom4} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ livingcumbedroom5} class="d-block w-100" alt="..."/>
                            </div>
                            <div class="carousel-item">
                                <img src={ livingcumbedroom6} class="d-block w-100" alt="..."/>
                            </div>
                        </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                            </button>
            </div>
            <div className='images-details mt-3'>
                <p className='img-details-and-btn'>An Industrial Style Bedroom design <Link className='btn form-btn' to= "/form">Get a Quote</Link></p>
    
                {/* Show More button */}
                {!isExpanded2 && (
                    <button
                    className=" show-more btn mt-2"
                    onClick={toggleContent2}
                    aria-expanded={isExpanded2}
                    >
                    Show More ▼
                    </button>
                )}
    
                {/* Expanded content */}
                {isExpanded2 && (
                    <div className="extra-info mt-3 ">
                        <p className='extra-info-para'>
                          An industrial style bedroom with an exposed brick wall and pops of color.An all black,sleek sliding door wardrobe lends an edgy look to this space
                        </p>
                        <p className='extra-info-features'>Special Features</p>
                        <ul className='extra-info-list'>
                            <li>A sliding door wardrobe with multiple compartments.</li>
                            <li>A study table adjoints the wardrobe built with overhead cabinets and shelves</li>
                            <li>A walk in dresser unit with tall shelves on the side</li>
                        </ul>
        
                        {/* Show Less button */}
                        <button
                            className=" show-less btn  mt-3"
                            onClick={toggleContent2}
                            aria-expanded={isExpanded2}
                        >
                            Show Less ▲
                        </button>
                    </div>
                )}
            </div>
        <div style={{margin:'80px'}}  ></div>


            {/* slider 5 end*/}
        </div>        
        {/* ******************************** */}
        
        
              {/*whychooseourkitchen*/}
              <div className='whyourkitchen'>
                <h3>Why Choose Our Bedroom Designs</h3>
                 <div className='whyourkitchen-reason'>
                  <div className='icon-para-div1'>
                    <BiSolidOffer className='icon'/>
                    <p className='whyourkitchen-para'>20% Extra Space</p>
                  </div>
                  <div className='icon-para-div1'>
                    <MdOutlineReplay10  className='icon'/>
                    <p className='whyourkitchen-para'>10 Year Warranty</p>
                  </div>
                  <div className='icon-para-div1'>
                    <MdOutlineThumbUpAlt  className='icon'/>
                    <p className='whyourkitchen-para'>Installation by Professionals</p>
                  </div>
                 </div>
              </div>
        
              {/*whychooseourkitchen*/}

               {/* FAQ's for kitchen */}
       <div className=' design gallery faq'>
        <h2 className=' design faq-heading'>Frequently asked questions on Bedroom Designs</h2>
        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="container accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1. What is the best way to design a functional and stylish bedrrom ?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Creating the perfect bedrrom designs involves perfect balance between functionality
                and style. A well-planned bedroom interior should reflect youur personality while ensuring 
                maximum comfort and efficient space utilisation. Here's how ypu can achieve that:
                <ul><br/>
                    <li><b>Smart Furniture Choices : </b>A modern bedrrom design requires a comfortable bed, well-designed wardrobes, and a nightstand for convenience. A bedroom design interior should also include a study nook or reading corner, depending on your needs.</li>
                    <li><b>Storage Solutions : </b>Maximise space with built-in wardrobes, under-bed storage,floating shelves, and modular cupboards to keep your bedroom interior design clutter-free</li>
                    <li><b>Color and Ambience : </b>The interior of your bedroom should have a soothing colour palette that aligns with your personal taste, whether it's neutral, pastel or bold accent tones.</li>
                    <li><b>Lighting Setup : </b>A combination of ambient lighting, task lighting and accent lights can elevate the interior design for our bedroom, making it cosier and more inviting.</li>
                    <li><b>Decor and Accessories </b>:Enhance the interior  design bedroom with wall art, mirrors, ruugs, throw oillows and decorative accents to create a more stylish appeal</li>
                </ul><br/>

                A functional and stylish bedroom interior should not just look good- it should feel comfortable, well-lit and highly practical for daily living.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. What are the key elements of a well-designed bedroom ?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 A well-designed bedroom interior should be aesthetically pleasing, comfortable and efficinetly organised.
                 The core elements of a great bedroom design interior include :  
                <ul><br/>
                    <li><b>A comfortable Bed: </b>The centrepiece of any bedroom interior design, a high-quality bed and mattress provide the foundation for restful sleep.</li>
                    <li><b>Smart Storage :Integrated wardrobes, under-bed storage, and modular cabinets optimise the interior design for bedrooms. </b></li>
                    <li><b>A Thoughtful Layout : </b>The bedroom design should ensure esy movement and funhctionality. making the space feel open and uncluttered.</li>
                    <li><b>Balanced Colour Palatte : </b>The right bedroom interior colours can make the space feel cosy elegant or modern , depending on the chosen hues.</li>
                    <li><b>Layered Lighting : </b>A combination of natural light, pendant lights and bedside lamps enhances the bedroom interior design aesthetics.</li>
                    <li><b>Personalised Decor</b>The interior of your bedroom should reflect your taste with wall art, rugs and stylish accessories.</li>
                </ul><br/>

                Every bedroom design should be a blend of comfort, personal expression and smart functionality.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3.Which colour combinations are ideal for bedroom interiors ?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 Your bedroom's colour scheme should reflect your personality and mood preferences. Which some love calm neutrals , othersprefer bold and vibrant tones.
                 Here are some trendy bedroom colour combinations for an aesthetics pleasing bedroom interior : 

                <ul><br/>
                    <li><b>Classic Blue and White: </b>A timeless duo that enhances the modern bedroom design aesthetic.</li>
                    <li><b>Blush Pink and Beige :</b>A warm and inviting palette for a soft, sophisticated bedroom interior. </li>
                    <li><b>Bottle Green and Brown : </b> A rich, nature-inspired bedroom design interior.</li>
                    <li><b>Grey and Teal: </b>A contemporary colour combination for an elegant bedroom design.</li>
                    <li><b>Peach and Olive Green : </b>A unique, earthy theme for a fresh and lively bedroom interior.</li>
                    <li><b>Coral and White</b>Bright and airy, perfect for minimalist interior design bedroom.</li>
                </ul><br/>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4.What are the latest in bedroom design?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Modern bedroom designs in 2025 focus on practicality , aethetics and sustainability. here's what's trending in 
                bedroom interior design : 

                <ul><br/>
                    <li><b>Biophilic Elements: </b>Nature-inspired decor, organic textures and earthy tones dominate bedroom designs.</li>
                    <li><b>Minimalist Bed+:</b>A warm and inviting palette for a soft, sophisticated bedroom interior. </li>
                    <li><b>Bottle Green and Brown : </b> A rich, nature-inspired bedroom design interior.</li>
                    <li><b>Grey and Teal: </b>A contemporary colour combination for an elegant bedroom design.</li>
                    <li><b>Peach and Olive Green : </b>A unique, earthy theme for a fresh and lively bedroom interior.</li>
                    <li><b>Coral and White</b>Bright and airy, perfect for minimalist interior design bedroom.</li>
                </ul><br/>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. What are the most popular bedroom styles and how do i choose the right one?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
               when choosing a bedroom design, consider space, lifestyle , and personal taste
               Here are some popular bedroom styles to explore:  

                <ul><br/>
                    <li><b>Modern Bedroom Design: </b>Minimalist , sleek and stylish with  neutral tones and furniture lines..</li>
                    <li><b>Minimalist Bed+:</b>A warm and inviting palette for a soft, sophisticated bedroom interior. </li>
                    <li><b>Bohemian Chic : </b> Eclectic mix of patterns, bold colours ad neutral textures.</li>
                    <li><b>Grey and Teal: </b>A contemporary colour combination for an elegant bedroom design.</li>
                    <li><b>Industrial Loft : </b>Raw, unfinished elements with exposed brick and rustic wood.</li>
                </ul><br/>
                Your bedroom design should align with functionality and aesthetics, making it both visually appealing
                and comfortable.
              </div>
            </div>
          </div>
        </div>
       </div>





                   <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>
        </div>

    </div>
  )
}

export default Bedroom